import { axiosInstance } from "api/services/axiosInstance";
import { ORG_USER_URL } from "constants/ApiConstants";

const organisationApi = {
  getOrganizationUsersListAPI: (searchKeys, cancelToken) => {
    return axiosInstance.get(`org/users`, {
      params: { ...searchKeys },
      cancelToken,
    });
  },
  activateOrganizationUserAPI: (orgUserId) => {
    return axiosInstance.put(`${ORG_USER_URL}/${orgUserId}/activate`);
  },
  deactivateOrganizationUserAPI: (orgUserId) => {
    return axiosInstance.put(`${ORG_USER_URL}/${orgUserId}/deactivate`);
  },
  assignRoleToOrganizationUserAPI: (orgUserId, role) => {
    return axiosInstance.post(`${ORG_USER_URL}/${orgUserId}/role/${role}`);
  },
  removeRoleToOrganizationUserAPI: (orgUserId, role) => {
    return axiosInstance.delete(`${ORG_USER_URL}/${orgUserId}/role/${role}`);
  },
  removeOrganizationUserAPI: (orgUserId) => {
    return axiosInstance.delete(`${ORG_USER_URL}/${orgUserId}`);
  },
  getOrgRoles: (orgId) => {
    return axiosInstance.get(`org/usersRoles/${orgId}`);
  },
};

export default organisationApi;
